import React from "react";
import { Link } from "react-router-dom";
import { components } from "griddle-react";
import { List, Map } from "immutable";
import { map } from "lodash";

import { ArtistImage } from "../ArtistImage";
import { Artist } from "../../models";

interface Props {
    showImage?: boolean;
    artists: Artist[];
}

export const ArtistsList = ({ artists, showImage }: Props) => (
    <span className="artists-list">
        {artists && artists.map((artist, i) => [
            i > 0 && !showImage &&  ", ",
            artist.id != null && (
                <Link key={i} to={artist.getViewUrl()}>
                    {showImage && <ArtistImage artist={artist} />}
                    {artist.getName()}
                </Link>),
            artist.id == null && (
                <>
                    {showImage && <ArtistImage artist={artist} />}
                    {artist.getName()}
                </>),
        ])}
    </span>
);

export const CellArtistsList = ({ value }: components.CellProps) => {
    let artists: Artist[] = value;
    if (value != null && !Array.isArray(value)) {
        const list = value as List<Map<string, any>>;
        artists = map(list.toArray(), (mp) => new Artist(mp.toObject()));
    }
    else if (value != null && Array.isArray(value) && value.length > 0 && !(value[0] instanceof Artist)) {
        artists = map(value, (mp) => new Artist(mp));
    }
    return <ArtistsList artists={artists} />;
};
